module.exports = __webpack_public_path__ + "static/img/t7.a4bfb37.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/about/t7.jpg
// module id = TJ8d
// module chunks = 0